import axios from 'axios';
import { format } from 'date-fns';
import { default as packageData } from '../../package.json';

const api = axios.create({
  baseURL: process.env.REACT_APP_METRICS_LOG_IN_OUT,
});

type RegisterProps = {
  acao: 'LOGIN' | 'LOGOFF';
  usuario: string;
  email: string;
  unidade: number;
};

// Ninguém espera esta chamada: sem o catch na promise, a falha virava erro não
// tratado (e o overlay do dev server por cima do login).
export function metricsRegister(params: RegisterProps): void {
  api
    .get('/v2/acessos/logInOut', {
      data: {
        ...params,
        plataforma: 'painel-indicadores',
        versao: packageData.version,
        dataOcorrencia: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      },
    })
    .catch((error) => {
      console.error(`Não foi possível realizar o registro no Metrics, erro\r\n: ${error}`);
    });
}
